<template>
  <div>
    <div class="businesscooperation">
      <banner-bg
        title="驱动合作伙伴不断赢得成功"
        subtitle="赋能赛事的价值"
        :src="require('@/assets/images/mainindex/cooperation-banner@2x.png')"
      ></banner-bg>
      <div class="businesscooperation_list container_wrap"  v-if="false" v-html="row.content">
        <div
            v-if="false"
          class="businesscooperation_list_item_container"
          v-for="(item, index) in 6"
          :key="index"
        >
          <div class="businesscooperation_list_item">
            <img src="~@/assets/images/mainindex/pic-zhaoshang@2x.png" alt="" />
            <div class="businesscooperation_list_item_title">
              分站赛招商方案
            </div>
            <div class="businesscooperation_list_item_subtitle">
              全国啦啦操分站赛是中国影响力最大的赛事之一
            </div>
            <div class="businesscooperation_list_item_tips">
              冠名 ｜秩序册 ｜ 巨幅海报 ｜ APP ｜ 央视
            </div>
            <el-divider></el-divider>
            <div class="businesscooperation_list_item_tags">
              <div class="businesscooperation_list_item_tags_el">
                <div class="businesscooperation_list_item_tags_el_num">
                  228,737
                </div>
                <div class="businesscooperation_list_item_tags_el_font">
                  人次
                </div>
              </div>
              <div class="businesscooperation_list_item_tags_el">
                <div class="businesscooperation_list_item_tags_el_num">32</div>
                <div class="businesscooperation_list_item_tags_el_font">
                  媒体
                </div>
              </div>
              <div class="businesscooperation_list_item_tags_el">
                <div class="businesscooperation_list_item_tags_el_num">992</div>
                <div class="businesscooperation_list_item_tags_el_font">
                  报道
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="partner_title"  v-if="false">合作伙伴</div>
<!--      <img-->
<!--        src="~@/assets/images/mainindex/pic-cooperativepartners@2x.png"-->
<!--        alt=""-->
<!--        class="partner_img"-->
<!--      />-->
      <div class="container_wrap partner-box"  v-if="false">
        <div class="partner-li" :style="'width: ' + (100 / list.length - 1) +'%'" v-for="(row,i) in list"  v-rblink="{name:'CmsDetail',query:{id:row.id}}">
          <img :src="row.pic_url"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BannerBg from "@/components/mainindex/BannerBg";
export default {
  name: "BusinessCooperation",
  components: {
    BannerBg,
  },
  data() {
    return {
      list: [],
      row: {
        content: ''
      }
    }
  },
  mounted() {
    document.title = "商务合作"
    this.getList()
    this.getNew()
  },
  methods: {
    getList() {
      let that =this
      that.$api.get(
          "/api/cms/cmsList", {
            cate_id: 53,
            pageNo: 1,
            pageSize: 10
          },
          res => {
            that.list = res.data.list
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },
    getNew() {
      let that =this
      that.$api.get(
          "/api/cms/detail", {
           id: 323
          },
          res => {
            that.row = res.data.data
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    }
  }
};
</script>
<style scoped>
.businesscooperation_list >>> img {
  max-width: 100%;
}
</style>
<style lang="scss" scoped>
.partner-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .partner-li {
    background: #fff;
    border-radius: 20px;
    cursor: pointer;
    text-align: center;
    img {
      //width: 100%;
      height: 160px;
    }
  }
}


.container_wrap {
  width: 1200px;
  margin: 0 auto;
}
.businesscooperation {
  background: #f8f8f8;
  min-height: 600px;
  padding-bottom: 30px;
}
.businesscooperation_list {
  margin-top: 73px;

  .businesscooperation_list_item_container {
    margin-right: 30px;
    margin-bottom: 31px;
    display: inline-block;
    font-size: 0;
    box-sizing: border-box;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      cursor: pointer;
      .businesscooperation_list_item{
        box-shadow: 0px 10px 28px 0px rgb(155, 154, 154);
      }
    }
    .businesscooperation_list_item {
      width: 380px;
      height: 501px;
      background: #ffffff;
      box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      img {
        // width: 379px;
        width: 100%;
        height: 267px;
        object-fit: cover;
      }
      .businesscooperation_list_item_title {
        width: 100%;
        height: 32px;
        font-size: 22px;
        font-weight: 500;
        color: #000000;
        line-height: 32px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 24px;
        margin-left: 12px;
        margin: 24px 0 0 12px;
        box-sizing: border-box;
      }
      .businesscooperation_list_item_subtitle {
        width: 100%;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #444444;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 14px 0 0 12px;
        box-sizing: border-box;
      }
      .businesscooperation_list_item_tips {
        max-width: 100%;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
        text-overflow: ellipsis;
        margin: 14px 0 0 12px;
      }
      /deep/.el-divider--horizontal {
        margin: 10px 0 20px 0;
      }
      .businesscooperation_list_item_tags {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        box-sizing: border-box;
        .businesscooperation_list_item_tags_el {
          flex: 1;
          .businesscooperation_list_item_tags_el_num {
            height: 33px;
            font-size: 30px;
            font-weight: bold;
            color: #000000;
            line-height: 34px;
            text-align: center;
          }
          .businesscooperation_list_item_tags_el_font {
            height: 32px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 32px;
            text-align: center;
            margin-top: 3px;
          }
        }
      }
    }
  }
}
.partner_title {
  width: 128px;
  margin: 0 auto;
  height: 45px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 45px;
  margin-top: 44px;
  margin-bottom: 31px;
}
.partner_img {
  display: block;
  width: 1200px;
  height: 89px;
  object-fit: cover;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// BusinessCooperation.vue?6156c139